module.exports = __webpack_public_path__ + "img/next.0b5ae0da.svg";